import React from 'react'

const GreenTick: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M3.09375 10.3438L7.03125 14.2812L14.9062 5.84375"
      stroke="#4ED052"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default GreenTick
